import React, { createContext, useContext, Component } from "react";
import { GlobalContext } from "../utils/globalprovider.js"

import { apiCreateNewVideoFromUpload, apiUploadSendChunk,apiCreateOneAsset, apiSaveAsset, apiSaveFileDirect } from "../utils/apis.js"

import "./upload.css"

class OneUpLoad extends React.Component
{
  static contextType = GlobalContext; 

  constructor(props) 
  {
    super(props);

    this.state = {
        startTime: this.getLocalTime(),
        projectid: this.props.projectId,
        formulaire: this.props.formulaire,
        error: false,
        pourcent:0,

    }

    this.totalChunks = 0;
    this.chunkSize = 1024 * 1023;
    this.chunkIndex = 0;

    this.uploadNextChunk = this.uploadNextChunk.bind(this);
    this.endOfDownload = this.endOfDownload.bind(this);

    if ((this.props.type === 2) || (this.props.type==4))
      this.uuid = this.props.formulaire.filenamesource;
    else
      if (this.props.type === 3 )
        this.uuid = this.props.formulaire.asfile;
      else
        this.uuid = this.generateUUID();

    this.totalsend = 0;
    this.isstarted = false;

  }

  componentDidMount()
  {
    // on va lancer le televersement
    this.totalChunks = this.state.formulaire.uploadfile.size / this.chunkSize;
    if (!this.isstarted)     
    {
      this.isstarted = true;
      this.uploadOneChunk();
    }


  }

  generateUUID() 
  {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);

    array[6] = (array[6] & 0x0f) | 0x40; // Version 4
    array[8] = (array[8] & 0x3f) | 0x80; // Variant 1

    return [...array].map((byte, index) => {
        const hex = byte.toString(16).padStart(2, '0');
        return ([4, 6, 8, 10].includes(index) ? '-' : '') + hex;
    }).join('');
}

getFileExtension(filename) {
  const lastDotIndex = filename.lastIndexOf(".");
  return lastDotIndex !== -1 ? filename.slice(lastDotIndex + 1) : "";
}

  uploadNextChunk(status, datas)
  {


    
     if ((status == null) || (!status.ret))
     {
        this.setState ({error: true});
        return;
     }
     this.totalsend = this.totalsend + this.chunkSize;

     
     var pc =  Math.ceil((this.chunkIndex / this.totalChunks) * 100);
     if (pc > 100) pc = 100;
     this.setState({pourcent: pc});

     this.chunkIndex++;
     if (this.chunkIndex < this.totalChunks)
        this.uploadOneChunk();

     if (this.totalsend >= this.state.formulaire.uploadfile.size)
     {

        switch (this.props.type)
        {
          case 0:// video

          var viconvfile = ''; // fichier converti
          var vicpfile = ''; // fichier des cp
          var viaudio1file = ''; // fichiers des audios
          var viaudio2file = ''; // fichiers des audios
          var vitranscriptionfile = ''; // fichier transcription
          var vitranscriptionaudiofile ='';
          var vitextsfile = ''; // detection textes
          var scefile = ''; // scenario
          var simpfile = ''; //simplifier

          /*
          if (this.props.formulaire.convert) viconvfile = this.generateUUID();
          if (this.props.formulaire.cp) vicpfile = this.generateUUID();
          if (this.props.formulaire.audio) viaudio1file = this.generateUUID();
          if (this.props.formulaire.audio) viaudio2file = this.generateUUID();
          if (this.props.formulaire.transcription) vitranscriptionfile = this.generateUUID();
          if (this.props.formulaire.transcription) vitranscriptionaudiofile = this.generateUUID();
          if (this.props.formulaire.texts) vitextsfile = this.generateUUID();
          */
          if (true) viconvfile = this.generateUUID();
          if (true) vicpfile = this.generateUUID();
          if (true) viaudio1file = this.generateUUID();
          if (true) viaudio2file = this.generateUUID();
          if (true) vitranscriptionfile = this.generateUUID();
          if (true) vitranscriptionaudiofile = this.generateUUID();
          if (true) vitextsfile = this.generateUUID();
          if (true) scefile = this.generateUUID();
          if (true) simpfile = this.generateUUID();

          var datas  = 
          {

            conv: this.props.formulaire.convert,
            convfile: viconvfile,

            audio: this.props.formulaire.audio,
            audio1file: viaudio1file,
            audio2file: viaudio2file,
            

            cp: this.props.formulaire.cp,
            cpfile: vicpfile,


            transcription: this.props.formulaire.transcription,
            transcriptionfile: vitranscriptionfile,
            transcriptionaudiofile: vitranscriptionaudiofile,
            transcriptiontype: this.props.formulaire.transcriptiontype,

            texts: this.props.formulaire.texts,
            textsfile: vitextsfile,

            title: this.props.formulaire.title,
            file: this.uuid,  // fichier downloaded

            orifile: this.props.formulaire.uploadfile.name,
            ext: this.getFileExtension(this.props.formulaire.uploadfile.name),
            createdate: this.getCurrentDate(),
            pjid: this.props.projectId, // si aspjid = 0 alors pas de creation d'asset
            lang: this.props.formulaire.language,

            iduser: this.props.formulaire.iduser,

            simp:this.props.formulaire.simp,
            simpopt:this.props.formulaire.simpopt,
            simpfile:simpfile,

            sce:this.props.formulaire.sce,
            sceopt:this.props.formulaire.sceopt,
            scefile:scefile,
            sceasidpdf:this.props.formulaire.sceasidpdf,

        }

          
          
          apiCreateNewVideoFromUpload (datas,this.endOfDownload)
          break;

          case 1: // Transcription originale & corrigée

            var datas  = 
            {
              asid: 0,
              aspjid: this.props.projectId,
              astype: this.state.formulaire.type, // transcription type
              asviid: this.state.formulaire.viid,
              asoriid: 0, // transcription originale
              astitle: this.props.formulaire.title,
              asfile: this.uuid,
              aslang: this.props.formulaire.language,
              asext: this.props.formulaire.ext,
              assubtype: this.props.formulaire.subtype,
              ascreatedate: this.getCurrentDate(),
              asupdatedate: this.getCurrentDate(),
              asframerate: this.props.formulaire.framerate,
              asnum: this.props.formulaire.num,
              asden: this.props.formulaire.den,
              asdropframe: this.props.formulaire.dropframe,
              astimecode: this.props.formulaire.timecode,
              ascoid: this.props.formulaire.ascoid,
            }
            apiCreateOneAsset (datas,this.endOfDownload)
            break;

         case 2: // update transcription corrigée or st auto or sequence

            var datas = 
            {
                asid: this.props.formulaire.asid,
                aspjid: this.props.formulaire.aspjid,
                astype: this.props.formulaire.astype,
                source: this.props.formulaire.filenamesource,
                dest: this.props.formulaire.filenamedest,
                asupdatedate: this.props.formulaire.asupdatedate,
            }
            apiSaveAsset (datas,this.endOfDownload)
            break;

         case 3: // create fichier de sous titre corrigée
            var datas  = 
            {
              asid: 0,
              aspjid: this.props.projectId,
              astype: 4, // sous titre corrigés
              asviid: this.props.formulaire.asviid,
              asoriid: this.props.formulaire.asoriid, // transcription corrigée
              astitle: this.props.formulaire.astitle,
              asfile: this.uuid,
              aslang: this.props.formulaire.aslang,
              asext: this.props.formulaire.asext,
              assubtype: this.props.formulaire.assubtype,
              ascreatedate: this.props.formulaire.ascreatedate,
              asupdatedate: this.props.formulaire.asupdatedate,
              asframerate: this.props.formulaire.asframerate,
              asnum: this.props.formulaire.asnum,
              asden: this.props.formulaire.asden,
              asdropframe: this.props.formulaire.asdropframe,
              astimecode: this.props.formulaire.astimecode,
              ascoid: this.props.formulaire.ascoid,
            }
            
            apiCreateOneAsset (datas,this.endOfDownload)
            break;

         case 4: // creation directe d'un fichier 
            var datas  = 
            {
                asid: this.props.formulaire.id,
                aspjid: this.props.formulaire.aspjid,
                astype: this.props.formulaire.astype,
                source: this.props.formulaire.filenamesource,
                dest: this.props.formulaire.filenamedest,
                asupdatedate: this.props.formulaire.asupdatedate,
            }
            apiSaveFileDirect (datas,this.endOfDownload)
            break;

          case 5: // ajout d'un fichier de sous titre original
          case 55: // ajout d'un fichier de sous titre corrigé
          
            
            var datas  = 
            {
              asid: 0,
              aspjid: this.props.projectId,
              astype: this.props.formulaire.type, // 
              asviid: this.props.formulaire.asviid,
              asoriid: this.props.type==5?0:this.props.formulaire.asoriid, // transcription originale
              astitle: this.props.formulaire.title,
              asfile: this.uuid,
              aslang: this.props.formulaire.language,
              asext: "json",
              assubtype: 0,
              ascreatedate: this.getCurrentDate(),
              asupdatedate: this.getCurrentDate(),
              asnum: this.props.formulaire.asnum,
              asden: this.props.formulaire.asden,
              asframerate: this.props.formulaire.asframerate,
              asdropframe: this.props.formulaire.asdropframe,
              astimecode: this.props.formulaire.astimecode,
              ascoid: this.props.formulaire.ascoid,
              
            }

            
            apiCreateOneAsset (datas,this.endOfDownload)
            break;


        case 6: // ajout d'un documents
            var datas  = 
            {
              asid: 0,
              aspjid: this.props.projectId,
              astype: 9, // 
              asviid: 0,
              asoriid: 0, // transcription originale
              astitle: this.props.formulaire.title,
              asfile: this.uuid,
              aslang: this.props.formulaire.language,
              asext: this.props.formulaire.ext,
              assubtype: 0,
              ascreatedate: this.getCurrentDate(),
              asupdatedate: this.getCurrentDate(),
              asnum: 25,
              asden: 1,
              asframerate: 25,
              asdropframe: 0,
              astimecode: "00:00:00:00",
              ascoid: 0,
            }
            
            
            apiCreateOneAsset (datas,this.endOfDownload)
            break;

      }

        
     }
  }

  getCurrentDate = () => {
    const today = new Date();
  
    const year = today.getFullYear(); // Année AAAA
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
    const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)
  
    return `${year}/${month}/${day}`;
  };


  endOfDownload(datas)
  {

    this.props.onfinish (this.props.id);
    if (this.props.callback !== null)
    {
      try{
        
        this.props.callback(datas);
        }
      catch(e)
      {
        console.log("upload callback error ", e)

      }
    }
  }

  uploadOneChunk()
  {

    if (this.totalChunks === 0)
    {
        this.setState({error:true});
        return;
    }
    const start = this.chunkIndex * this.chunkSize;
    const end = Math.min(start + this.chunkSize, this.state.formulaire.uploadfile.size);
    const chunk = this.state.formulaire.uploadfile.slice(start, end); // Extract the chunk    





    apiUploadSendChunk(this.uuid, this.state.formulaire.uploadfile.size, chunk, this.chunkIndex, this.chunkSize, this.totalChunks,this.uploadNextChunk);
    
    

  }


  getLocalTime()
  {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');   // Ensure two digits
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return  `${hours}:${minutes}:${seconds}`;    
  }

  renderProgressBar()
  {
      if (this.state.error)
      {
          return(<span style={{color:"red"}}>{this.context.language=="fr"?"Le téléversement à échoué.":"Upload failed."}</span>)
          
      }
      else
      {
        return (
        
          <div id="progressContainer" className="oneuploadpb1">
          <div id="progressBar" className="oneuploadpb2" style={{width:this.state.pourcent.toString()+"%"}}><span>{this.state.pourcent.toString()+"%"}</span></div>
          </div>
        )

      }
  }

  render ()
  {

    if (!this.props.visible) return (<></>);

    var start = this.context.language=="fr"?"Début:":"Start:";
    var title = this.context.language=="fr"?"Titre:":"Title:";
    var size = this.context.language=="fr"?"Taille:":"Size:";
    var file = this.context.language=="fr"?"Fichier:":"File:";

    const renderprogressbar = this.renderProgressBar();
    
    return (
        <div className="oneuploaddiv">
            <span style={{fontSize:10, color:"Gray"}}>{start}</span>&nbsp;
            <span style={{fontSize:10, color:"white"}}>{this.state.startTime}</span>&nbsp;
            <span style={{fontSize:10, color:"gray"}}>{size}</span>&nbsp;
            <span style={{fontSize:10, color:"white"}}>{this.state.formulaire.uploadfile.size}</span>
            <br/>
            <span style={{fontSize:10, color:"Gray"}}>{title}</span>&nbsp;
            <span style={{fontSize:10, color:"white"}}>{this.state.formulaire.title}</span>&nbsp;
            <br/>
            <span style={{fontSize:10, color:"Gray"}}>{file}</span>&nbsp;
            <span style={{fontSize:10, color:"white"}}>{this.state.formulaire.uploadfile.name}</span>&nbsp;
            <br/>
            {renderprogressbar}
            


        </div>
    )
  }

}

OneUpLoad.defautProps = 
{
    projectId: 0,
    formulaire: null,
    startTime:"00:00:00",
}

export default OneUpLoad;